import { FC } from 'react';

import { InputGroup, InputGroupText } from 'reactstrap';

import { DebouncedInput, FontAwesomeIcon, If } from '@hsp/react-component-library';

import { useTableStoreSelector, useTableStoreSet } from 'components/table/hooks';
import { IGlobalFilterProps } from 'types/components/table/components';

const GlobalFilter: FC<IGlobalFilterProps> = ({ enabled, placeholder = 'Search all columns...' }) => {
  const filter = useTableStoreSelector((state) => state.globalFilter);
  const setStore = useTableStoreSet();

  return (
    <If condition={enabled}>
      <InputGroup>
        <InputGroupText>
          <FontAwesomeIcon
            className="me-1"
            icon={['fas', 'magnifying-glass']}
          />
        </InputGroupText>
        <DebouncedInput
          onChange={(value) => setStore({ globalFilter: String(value) })}
          placeholder={placeholder}
          value={filter ?? ''}
        />
      </InputGroup>
    </If>
  );
};

export default GlobalFilter;
